import { graphql } from "@/graphql/codegen"

graphql(`
  query PaymentTermList($input: PaymentTermListInput!) {
    paymentTerm {
      list(input: $input) {
        __typename
        ... on PaymentTermListSuccess {
          paymentTerms {
            paymentTermId
            name
            options {
              parts {
                paymentRule {
                  daysAfter
                  event
                  percentage
                }
                discount {
                  percentage
                  applicableIfWithinDays
                }
              }
            }
            payRunSchedule {
              payPattern
              startDate
              payDays
              invoiceMaturity {
                intervalBetweenPayRuns
                offsetInDays
              }
            }
            createdOn
            updatedOn
          }
        }
        ... on PaymentTermListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPaymentTerm($input: PaymentTermGetInput!) {
    paymentTerm {
      get(input: $input) {
        __typename
        ... on PaymentTermGetSuccess {
          paymentTerm {
            paymentTermId
            name
            options {
              parts {
                paymentRule {
                  daysAfter
                  event
                  percentage
                }
                discount {
                  percentage
                  applicableIfWithinDays
                }
              }
            }
            payRunSchedule {
              payPattern
              startDate
              payDays
              invoiceMaturity {
                intervalBetweenPayRuns
                offsetInDays
              }
            }
            createdOn
            updatedOn
          }
        }
        ... on PaymentTermGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
